<template>
    <div>
        <div class="ei-home-body">
            <div class="body-one" ref="bodyOne">
                <slot name="one"></slot>
            </div>
            <div :class="{'body-two':true,'cover':cover}" ref="bodyTwo" id="bodyTwo">
                <slot name="two"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EiHomeBody',
        data() {
            return {
                winHeight: window.innerHeight,
            }
        },

        props: {
            cover: {
                type: Boolean,
                default: false
            }
        },
        watch: {}
    }
</script>

<style scoped lang="scss">
    .ei-home-body {
        .body-one {
            width: 100%;
            overflow: hidden;
        }

        .body-two {
            position: fixed;
            width: 100%;
            left: 0;
            top: 100%;
            bottom: 0;
            right: 0;
            transition: top 0.7s cubic-bezier(0.5, 0, 0.2, 1) 0s;
            z-index: 1;
            outline: none;
            background-color: #fff;
            overflow-x:hidden;
        }

        .body-two.cover {
            top: 0;
        }
    }
    * img,span,a,div{
      user-select: none;
      -webkit-user-drag:none;
    }
</style>
